import { useDispatch, useSelector } from "react-redux";

import { IUserLoggedEntity } from "@/shared/models/interfaces/entity/user-logged/user-logged.entity";

import UserLoggedSlice from "./auth.slice";

const { clearUserLogged, setUserLogged, updateCompleteProfile } =
  UserLoggedSlice.actions;

export const useLoggedUser = () => {
  const dispatch = useDispatch();
  const userLogged: IUserLoggedEntity = useSelector(
    (state: any) => state[UserLoggedSlice.name]
  );
  const clearUser = () => dispatch(clearUserLogged());
  
  const setUserData = (user: IUserLoggedEntity) => dispatch(setUserLogged(user));

  const updateCompleteProfileUser = (isProfileFinished: number) =>
    dispatch(
      updateCompleteProfile({
        isProfileFinished: isProfileFinished
      })
    );

  return { userLogged, clearUser, setUserData, updateCompleteProfileUser };
};
